module.exports = __webpack_public_path__ + "static/hero-mobile-66ee4bf3d0a2daa0a394e54f36337899.png";